/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsAjaxCart = {
  init: function ($section) {

//     jQuery(".toggle-btn").change(function(){
//           jQuery("#upload-photo").slideToggle('fast');
//         });

    // Add settings from schema to current object
    Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
      //  Shopify.theme.jsAjaxCart.showDrawer();

        return false;
      });

    } else if (this.cart_action == 'mini_cart') {
    //  this.showMiniCartOnHover();

    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');

      Shopify.theme.jsAjaxCart.addToCart($addToCartForm);

      return false;
    });

    $(document).on('click', '.ajax-submit-direct', function (e) {
      e.preventDefault();
      const $line_item_id = $(this).attr("data-id");
    //  console.dir($(this));
    //  console.dir($line_item_id);
      Shopify.theme.jsAjaxCart.addToCartDirect($line_item_id,1);

      return false;
    });





    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).parents('[data-line-item]').data('line-item');
      Shopify.theme.jsAjaxCart.removeFromCart(lineID);

      if (Shopify.theme.jsCart) {
        Shopify.theme.jsCart.removeFromCart(lineID);
      }

      return false;
    });

    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      Shopify.theme.jsAjaxCart.hideDrawer();
      Shopify.theme.jsAjaxCart.hideMiniCart();

      return false;
    });

  },


  addToCartDirect: function (variant_id,qty) {

    data = {
      "id": variant_id,
      "quantity": qty
    }

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {
        Shopify.theme.jsAjaxCart.updateView();
         location.reload();
      }
    });


},

  showMiniCartOnHover: function () {
    const $el = $('[data-ajax-cart-trigger]');

  if (isScreenSizeLarge()) {
    $el.hover(function() {

      if(Shopify.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function() {
      $el.removeClass('show-mini-cart');
    });
  }
  },
  hideMiniCart: function () {
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      // Loads content into ajaxCart container for mobile header
      Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile();

      // If user clicks outside the element, toggle the mini cart
      $el.toggleClass('show-mini-cart');
    });
  },
  showDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
  },
  hideDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
  },
  removeFromCart: function (lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        Shopify.theme.jsAjaxCart.updateView();
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  },



  initializeAjaxCart: function () {

    Shopify.theme.asyncView.load(
      Shopify.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('[data-ajax-cart-content]').html(html.content);

        // Converting the currencies
        if (Shopify.theme.currencyConverter) {
          Shopify.theme.currencyConverter.convertCurrencies();
        }

      })
      .fail(() => {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile: function () {

  //  this.toggleMiniCart();

    Shopify.theme.asyncView.load(
      Shopify.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('.mobile-header [data-ajax-cart-content]').html(html.content);

      })
      .fail(() => {
        // some error handling
      });
  },

  addEngraveToCart: function (variant_id, product_title, engraving_text, _item_key) {

        data = {
      "id": variant_id,
      "quantity": 1,
      "properties": {
        "Engraving For Product": product_title,
        "_item_key": _item_key
      }
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {
          Shopify.theme.jsAjaxCart.updateView();
      }
    });

    },


  addToCart: function ($addToCartForm) {
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
    const $show_additional_services = $addToCartForm.parent().attr("data-show_additional_services");

    // You need to use standard javascript object here
    // create form data with all the fields from the form
    // FormData is >=IE10
    const $formData = new FormData($addToCartForm[0]);

    //customid-personalized-engraving - required engraving textarea
      // var $customid_personalized_engraving = $addToCartForm.find('#customid-personalized-engraving');
      var $customid_personalized_engraving_exists = $('.shopify-product-form #customid-personalized-engraving').length;
      if($customid_personalized_engraving_exists){
        var $customid_personalized_engraving = $addToCartForm.find('#customid-personalized-engraving');
        console.dir($customid_personalized_engraving.val());


        if($customid_personalized_engraving.val().trim().length == 0 ) {
              const cartWarning = `<p class="cart-warning__message animated bounceIn">Please enter your engraving text</p>`;
              $('.warning').remove();
          $addToCartForm
            .addClass('shopify-product-form--unselected-error')
            .find('.cart-warning')
            .html(cartWarning);


                      $addToCartBtn
                        .removeAttr('disabled')
                        .removeClass('disabled');

                      $addToCartBtn.find('.icon')
                        .removeClass('zoomOut')
                        .addClass('zoomIn');

                      $addToCartBtn
                        .find('span:not(.icon)')
                        .text($addToCartBtn.data('label'))
                        .removeClass('zoomOut')
                        .addClass('zoomIn');

                        return false;


        }

      }


    //has file upload?
    var $image_upload_value = $addToCartForm.find('#upload_svg').val();
    var $image_size_ok = true;
      if($image_upload_value) {
          var input = document.getElementById('upload_svg');
          if (!input.files) { // This is VERY unlikely, browser support is near-universal
              console.error("This browser doesn't seem to support the `files` property of file inputs.");
          } else if (!input.files[0]) {
              console.log("Please select a file before clicking 'Load'");
          } else {
              var file = input.files[0];
              console.log("File " + file.name + " is " + file.size + " bytes in size");
              if(file.size > 20000000) {
                console.dir('too big file');
                $image_size_ok = false;
              }
          }
        }

    $addToCartForm.removeClass('shopify-product-form--unselected-error');

    if ($addToCartBtn[0].hasAttribute('data-options-unselected') || !$image_size_ok ) {
      if($addToCartBtn[0].hasAttribute('data-options-unselected')) {
          const cartWarning = `<p class="cart-warning__message animated bounceIn">${Shopify.translation.select_variant}</p>`;

          $('.warning').remove();

          $addToCartForm
            .addClass('shopify-product-form--unselected-error')
            .find('.cart-warning')
            .html(cartWarning);


          $addToCartBtn
            .removeAttr('disabled')
            .removeClass('disabled');

          $addToCartBtn.find('.icon')
            .removeClass('zoomOut')
            .addClass('zoomIn');

          $addToCartBtn
            .find('span:not(.icon)')
            .text($addToCartBtn.data('label'))
            .removeClass('zoomOut')
            .addClass('zoomIn');
      }

      if(!$image_size_ok){
        const cartWarning = `<p class="cart-warning__message animated bounceIn">File size must be under 20mb.</p>`;
            $('.warning').remove();
        $addToCartForm
          .addClass('shopify-product-form--unselected-error')
          .find('.cart-warning')
          .html(cartWarning);


                    $addToCartBtn
                      .removeAttr('disabled')
                      .removeClass('disabled');

                    $addToCartBtn.find('.icon')
                      .removeClass('zoomOut')
                      .addClass('zoomIn');

                    $addToCartBtn
                      .find('span:not(.icon)')
                      .text($addToCartBtn.data('label'))
                      .removeClass('zoomOut')
                      .addClass('zoomIn');
      }

    } else {

    //  console.dir($formData);
      //todo: before add to cart, check for engraving.  if engraving, add it to cart, then add the normal item, then update the engraving


      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        contentType: false, // NEEDED, DON'T OMIT THIS (requires jQuery 1.6+)
        processData: false, // NEEDED, DON'T OMIT THIS
        data: $formData,
        beforeSend: function () {


          $addToCartBtn
            .attr('disabled', 'disabled')
            .addClass('disabled');

          $addToCartBtn.find('span')
            .removeClass("fadeInDown")
            .addClass('animated zoomOut');

            if($image_upload_value) {
              $addToCartBtn.find('.add-to-cart-waiting')
                .removeClass("hidden");
                $addToCartForm.find('.please-wait-text')
                  .removeClass("hidden");
            }





        },
        success: function (product) {

          var itemAddedKey = product.key;

          let $el = $('[data-ajax-cart-trigger]');

          $addToCartBtn
            .find('.checkmark')
            .addClass('checkmark-active');

            $addToCartBtn.find('.add-to-cart-waiting')
              .addClass("hidden");

              $addToCartForm.find('.please-wait-text')
                .addClass("hidden");

          function addedToCart() {

            if (!isScreenSizeLarge()) {
              $el = $('.mobile-header [data-ajax-cart-trigger]');
              Shopify.theme.scrollToTop($el);
            } else {
              $el = $('[data-ajax-cart-trigger]');
            }

          //  $el.addClass('show-mini-cart');

            $addToCartBtn.find('span')
              .removeClass('fadeInDown');




          }



          window.setTimeout(function () {
            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.checkmark')
              .removeClass('checkmark-active');

            $addToCartBtn.find('.text, .icon')
              .removeClass('zoomOut')
              .addClass('fadeInDown');

            $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

          }, 1000);

          Shopify.theme.jsAjaxCart.showDrawer();
          Shopify.theme.jsAjaxCart.updateView();



          if (Shopify.theme.jsCart) {
            $.ajax({
              dataType: "json",
              async: false,
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);

              }
            });
          }

          /*custom */
        //  console.dir(product);

           //get line item of product just added to cart, hide pdp page content, show related products and the product you just added to cart

           $.ajax({
             type: 'GET',
             url: '/cart.js',
             dataType: 'json',
             success: function (cart) {

              var index = cart.items.findIndex(function(item) {
                  return item.key == itemAddedKey;
                });


                //check for lazer engraving

                if(cart.items[index].properties !== null && cart.items[index].properties !== '') {

                  if(cart.items[index].properties["Lazer Engraving"] || cart.items[index].properties["file"]) {
                    //has engraving, get engraving product, add it to cart with info about key

                    $.ajax({
                      type: 'GET',
                      url: '/products/lazer-engraving.js',
                      dataType: 'json',
                      success: function (product) {

                          var prod_title = cart.items[index].product_title +'-'+ cart.items[index].variant_title;
                          Shopify.theme.jsAjaxCart.addEngraveToCart(product.variants[0].id, prod_title, 'engrave text', itemAddedKey);


                      },
                      error: function (XMLHttpRequest, textStatus) {
                        var response = eval('(' + XMLHttpRequest.responseText + ')');
                        response = response.description;

                      }
                    });





                  }else{
                  //  console.dir('no engrave');
                  }
              }



                  // if($show_additional_services !== undefined) {
                  //       // show extra product options/value added products on pdp
                  //       // console.dir(index);
                  //       // console.dir(cart.items[index].product_title);
                  //       // console.dir(cart.items[index].variant_title);
                  //       // console.dir(cart.items[index].image);
                  //         if($show_additional_services == 'true') {
                  //         function showAdditionalServices() {
                  //           $('#product-main-content').fadeOut('fast');
                  //           $('#cart-product-image').attr("src",cart.items[index].image);
                  //           $('#cart-product-title').text(cart.items[index].product_title);
                  //           $('#cart-product-options').text(cart.items[index].variant_title);
                  //
                  //         //  var lazerEngravingVar = cart.items[index].properties["Lazer Engraving"];
                  //
                  //         //  console.dir(cart.items[index].properties.hasOwnProperty('Lazer Engraving'));
                  //         if(cart.items[index].properties != null) {
                  //             if(cart.items[index].properties["Lazer Engraving"] !=null) {
                  //
                  //               $('#cart-product-engraving').text("Lazer Engraving: " + cart.items[index].properties["Lazer Engraving"]);
                  //             }
                  //
                  //             if(cart.items[index].properties["file"]) {
                  //               // <a class="lightbox" href="{{ p.last }}">{{ 'cart.general.uploaded_file' | t }}</a>
                  //               $('#cart-product-engraving').html("Lazer Engraving: <a class='lightbox' href='" + cart.items[index].properties["file"] + "''>file</a>");
                  //
                  //             }}
                  //           $('#after-add-to-cart ').fadeIn('fast');
                  //           $('#shopify-section-after-add-to-cart-products').fadeIn('fast');
                  //           $header = $('header');
                  //           $('body').addClass('after-add-to-cart-products');
                  //           Shopify.theme.scrollToTop($el);
                  //         }
                  //
                  //         setTimeout(showAdditionalServices, 600);
                  //         }
                  //       }

             },
             error: function (XMLHttpRequest, textStatus) {
               var response = eval('(' + XMLHttpRequest.responseText + ')');
               response = response.description;

             }
           });





          // console.dir(product.handle);
        //    window.location = redirectPath;
          /*end custom*/

        },
        error: function (XMLHttpRequest) {


              var IS_JSON = true;
               try
               {
                       var json = JSON.parse(XMLHttpRequest.responseText);
               }
               catch(err)
               {
                       IS_JSON = false;
               }


               if(IS_JSON) {

                let response = eval('(' + XMLHttpRequest.responseText + ')');
                response = response.description;

                var $cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
              }else{
                  var dom_nodes = $($.parseHTML(XMLHttpRequest.responseText));
                //  console.dir(dom_nodes);
                  var $cartWarning = '<p class="cart-warning__message animated bounceIn">Error Uploading File</p>';
                  //  console.dir($cartWarning);
              }

          $('.warning').remove();

          $addToCartForm
            .find('.cart-warning')
            .html($cartWarning);

          $addToCartBtn
            .removeAttr('disabled')
            .removeClass('disabled');

          $addToCartBtn.find('.icon')
            .removeClass('zoomOut')
            .addClass('zoomIn');

          $addToCartBtn
            .find('span:not(.icon)')
            .text($addToCartBtn.data('label'))
            .removeClass('zoomOut')
            .addClass('zoomIn');
        }
      });
    }
  },


  updateView: function () {

    Shopify.theme.asyncView.load(
      Shopify.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
    .done(({ html, options }) => {



    //manually refresh cart
    var lastURLSegment = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
    if(lastURLSegment) {
      if(lastURLSegment == 'cart') {
        location.reload();
      }else{
        //go to cart
      //  window.location.href = "/cart";
      }
    }

      if (options.item_count > 0) {
        const itemList = $(html.content).find('.ajax-cart__list');
        const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');

        $('.ajax-cart__list').replaceWith(itemList);
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);

      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }

      if (Shopify.theme.currencyConverter) {
        Shopify.theme.currencyConverter.convertCurrencies();
      }
    })
    .fail(() => {
      // some error handling
    });
  },
  unload: function ($section) {

    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
}

/******/ })()
;
